import { render, staticRenderFns } from "./SubdomainModal.vue?vue&type=template&id=22a54533&scoped=true&"
import script from "./SubdomainModal.vue?vue&type=script&lang=js&"
export * from "./SubdomainModal.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainModal.vue?vue&type=style&index=0&id=22a54533&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a54533",
  null
  
)

export default component.exports